import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from '../../components/Navbar';
import { Hero } from '../../components/Hero';
import { About } from '../../components/About';
import { Capabilities } from '../../components/Capabilities';
import { Process } from '../../components/Process';
import { Contact } from '../../components/Contact';
import { Testimonials } from '../../components/Testimonials';
import { CursorFollower } from '../../components/CursorFollower';
import { ScrollProgress } from '../../components/ScrollProgress';
import { Reveal } from '../../components/Reveal';
import { Footer } from '../../components/Footer';
import { BankSafeIntro } from '../components/BankSafeIntro';

export const Home: React.FC = () => {
  const [isVaultUnlocked, setIsVaultUnlocked] = useState(false);
  const [darkMode, setDarkMode] = React.useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : true; // Default to dark
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <>
      <AnimatePresence>
        {!isVaultUnlocked && (
          <BankSafeIntro key="bank-safe-intro" onUnlock={() => setIsVaultUnlocked(true)} />
        )}
      </AnimatePresence>

      <Navbar 
        darkMode={darkMode} 
        toggleTheme={toggleTheme} 
        onShowSafeIntro={() => setIsVaultUnlocked(false)} 
      />
      <div className="min-h-screen bg-background text-foreground selection:bg-primary/20 selection:text-primary relative transition-colors duration-300 overflow-x-hidden">
        <ScrollProgress />
        <CursorFollower />
        
        <main className="relative z-10">
        <section id="home" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Hero />
        </section>
        
        <section id="about" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Reveal width="100%">
            <About />
          </Reveal>
        </section>
        
        {/* Swapped Position: Domain Agnostic Architecture & Execution */}
        <section id="capabilities" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Reveal width="100%" direction="up">
            <Capabilities />
          </Reveal>
        </section>

        <section id="process" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Reveal width="100%">
            <Process />
          </Reveal>
        </section>

        <section id="testimonials" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Reveal width="100%" direction="up">
            <Testimonials />
          </Reveal>
        </section>

        <section id="contact" className="scroll-section relative border-b border-border overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/[0.04] via-transparent to-transparent pointer-events-none -z-10"></div>
          <Reveal width="100%">
            <Contact />
          </Reveal>
        </section>
        
        <Footer />
      </main>
    </div>
    </>
  );
};


